import { createState, useState } from '@hookstate/core'
import { Persistence } from '@hookstate/persistence';
import { LoginState } from '../config/interfaces';

const initialState: LoginState = {
  loggedIn: false,
};

const authState = createState(initialState);
authState.attach(Persistence('auth'));

export const setAuth = (login: boolean) => {
  authState.set({
    loggedIn: login,
  });
};

export const useAuthState = () => useState(authState);
